<template>
	<div class=" login-wrap clearfix">
		<!-- 导航 -->
		<div class="main_top_nav1 clearfix">
			<div class="center_nav clearfix">
				<router-link :to="{name:'page_home'}"><img src="../../assets/logo1.png" class="nav_logo" /></router-link>
			</div>
		</div>
		<!-- 导航 -->
		
		<div class="middle_wrap clearfix">
			<div class="img1"></div>
			<div class="img2"></div>
			<div class="img3"></div>
			<div class="middle_box clearfix">
				<img src="../../assets/login_img1.png" class="login_img1" />
				
				<div class="login_module clearfix">
					<div class="title">登录<span> / LOGIN</span></div>
					<div class="txt">一站构建房产营销新生态</div>
					
					<div class="form_input_wrap clearfix">
						<el-form :model="Register" :rules="rules" ref="RegisterForm" class="RegisterForm">
							<el-form-item prop="phone">
								<el-input v-model="Register.phone" v-enter-number maxlength="11" placeholder="请输入手机号" class="phone_ipt"></el-input>
							</el-form-item>
							
							<el-form-item prop="code" class="reg_box">
								<el-input v-model="Register.code" v-enter-number maxlength="6" placeholder="请输入验证码" class="phone_ipt reg_ipt"></el-input>
								<el-button type="button" @click="sendcode" :disabled="disabled" v-if="disabled==false" class="get_button">获取验证码
								</el-button>
								<el-button type="button" @click="sendcode" :disabled="disabled" v-if="disabled==true" class="get_button">{{btntxt}}
								</el-button>
							</el-form-item>
							
							<el-form-item class="submit_btn">
								<el-button type="primary" @click="submitForm(Register)">
									{{loading? '登录中...' : '登录'}}
								</el-button>
							</el-form-item>
							<p class="hint_txt">验证码登录即为注册</p>
						</el-form>
						<!-- <el-form :model="Register" :rules="rules" ref="RegisterForm" label-width="0" class="RegisterForm">
							<el-form-item prop="phone">
								<el-input v-model="Register.phone" v-enter-number maxlength="11" placeholder="请输入手机号"></el-input>
								<el-button type="button" @click="sendcode" :disabled="disabled" v-if="disabled==false" class="send_btn">发送验证码
								</el-button>
								<el-button type="button" @click="sendcode" :disabled="disabled" v-if="disabled==true" class="send_btn">{{btntxt}}
								</el-button>
							</el-form-item>
							<el-form-item prop="code">
								<el-input v-model="Register.code" maxlength="6" placeholder="请输入验证码"></el-input>
							</el-form-item>
						
							<el-form-item>
								<el-button type="primary" @click="submitForm(Register)">
									{{loading? '登录中...' : '登录'}}
								</el-button>
							</el-form-item>
						</el-form> -->
					</div>
					
				</div>
			</div>
		</div>
		
		<!-- 底部 -->
		<div class="main_footer_wrap clearfix">
			<div class="cont_box clearfix">
				<div class="left_file_box clearfix">
					<p class="txt">copyright© 2010-2035 allright reserved.powered by 北京芒果铭天科技有限公司</p>
					<p class="txt">地址：北京朝阳区高碑店乡北花园村南3－1FC01号楼5层 523户</p>
					<a class="file_blk" target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502037286">
						<img src="http://cdn.woniuge.com//images/record-image.png" />
						京公网安备 11010502037286号  |  京ICP备18036803号
					</a>
				</div>
				
				<div class="right_qrcode clearfix">
					<div class="code" style="margin-right: 36px;">
						<img src="../../assets/gzh_qrcode.png" />
						<i>下载蜗牛哥APP</i>
					</div>
					<div class="code">
						<img src="../../assets/gzh_qrcode.png" />
						<i>关注公众号</i>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	let ms = []
	import {
		mapGetters
	} from 'vuex'
	import { Login, Send, Center} from '../../common/api/http.js' 
	export default{
		data(){
			return{
				loading: false,
				rules: {
					phone: [{
						required: true,
						message: "请输入手机号",
						trigger: 'blur'
					}],
					code: [{
						required: true,
						message: "请输入验证码",
						trigger: 'blur'
					}]
				},
				Register: {
					phone: '',
					code: '',
				},
				disabled: false,
				time: 0,
				btntxt: "重新发送",
			}
		},
		mounted() {
			
		},
		created() {
			// window.addEventListener('keydown', this.handkeyCode, true)//开启监听键盘按下事件
		},
		computed: {
			...mapGetters([
				'adminIndex'
			])
		},
		methods: {
			//手机验证发送验证码
			sendcode() {
				const reg = 11 && /^((13|14|15|17|18)[0-9]{1}\d{8})$/
				if (this.Register.phone == '') {
					this.$message({
						message: '手机号不能为空',
						center: true
					})
					return
				}
				if (!reg.test(this.Register.phone)) {
					this.$message({
						message: '请输入正确的手机号',
						center: true
					})
					return
				} else {
					this.$message({
						message: '发送成功',
						type: 'success',
						center: true
					});
					this.time = 60;
					this.disabled = true;
					this.timer();
					
					// 请求验证码
					let data = {
						'mobile': this.Register.phone,
						'action': '2'
					}
					Send(data).then(res => {
						console.log(res.data.code)
						// this.$message('验证码:'+res.data.code)
					})
				}
			},
			//60S倒计时
			timer() {
				if (this.time > 0) {
					this.time--;
					this.btntxt = this.time + "s后重新获取";
					setTimeout(this.timer, 1000);
				} else {
					this.time = 0;
					this.btntxt = "获取验证码";
					this.disabled = false;
				}
			},
			submitForm() {
				this.$refs.RegisterForm.validate((e) => {
					if (!e) return;
					this.loading = true
					// 登录
					let data = {
						'mobile': this.Register.phone,
						'sms_code':this.Register.code,
						'type':'1'
					}
					Login(data).then(res => {
						console.log(res)
						if(res.code==0){
							// console.log(res.data.token)
							// 请求我的
							Center({
								'api_token': res.data.token
							}).then(res=>{
								// console.log(res)
								if(res.code==0){
									// 存储到vuex
									let data = res.data
									// 存储到本地存储
									this.$store.commit('login', data)
									// 成功提示
									this.$message({
									  message: '登录成功!',
									  type: 'success'
									});
									this.loading = false
									// 跳转后台首页-是否认证通过
									if(data.certified ==0){
										this.$router.push({
											name: 'unverified_state'
										})
									}else if(data.certified ==1){
										this.$router.push({
											name: 'index'
										})
									}
									
								}
							}).catch(err => {
								this.loading = false
							})
						}
					}).catch(err => {
						this.loading = false
					})
				})
			},
			submit() {
				this.$refs.ruleForm.validate((e) => {
					if (!e) return;
					// 提交表单
					this.loading = true
					this.axios.post('/admin/login', this.form).then(res => {
						// 存储到vuex
						let data = res.data.data
						// console.log(JSON.stringify(data.tree))
						// 存储到本地存储
						this.$store.commit('login', data)
						// 存储权限规则
						if (data.role && data.role.rules) {
							window.sessionStorage.setItem('rules', JSON.stringify(data.role.rules))
						}
		
						var tree = this.$conf.navBar
						// 生成后台菜单
						this.$store.commit('createNavBar', tree)
						// 成功提示
						this.$message('登录成功')
						this.loading = false
						// 跳转后台首页
						this.$router.push({
							name: this.adminIndex
						})
					}).catch(err => {
						this.loading = false
					})
				})
			}
		},
		
	}
</script>

<style lang="less">
	button { outline: none;}
	button:focus{outline:0;} 
	.main_top_nav1 {
		width: 100%; height: 70px; border-bottom: none; position: initial; background: #fff;
		.center_nav {
			width: 1200px; height: 70px; margin: 0 auto; overflow: hidden;
			.nav_logo {
				width: 180px; height: 40px; float: left; margin-top: 15px; cursor: pointer;
			}
		}	
	}
	
	.middle_wrap {
		position: relative; width: 100%; min-width: 1200px;
		.img1 {
			min-width: 1200px; height: 215px; background: url(../../assets/login_bg1.png) top center no-repeat;
		}
		.img2 {
			min-width: 1200px; height: 215px; background: url(../../assets/login_bg2.png) center top no-repeat;
		}
		.img3 {
			min-width: 1200px; height: 219px; background: url(../../assets/login_bg3.png) center top no-repeat;
		}
		.middle_box {
			width: 1200px; height: 649px; position: absolute; left: 0; top: 0; right: 0; bottom: 0; margin: auto;
		}
		.login_img1 {
			width: 500px; height: 437px; position: absolute; left: 80px; top: 107px;
		}
		
		.login_module {
			width: 390px; height: 440px; background: #fff; position: absolute; right: 57px; top: 105px; overflow: hidden; padding-left: 34px; box-sizing: border-box;
			.title {
				font-size: 22px; color:#333; line-height: 1; font-weight: bold; margin-top: 40px;
				span { font-size: 16px;}
			}
			.txt {
				font-size: 14px; color:#666; line-height: 1; margin-top: 15px;
			}
			
			.form_input_wrap {
				width: 324px; margin-top: 36px;
				.el-input__inner {
					border: 1px solid #e5e5e5; border-radius: 0; padding: 0 36px;
				}
				.phone_ipt {
					&:after {
						width: 16px; height: 21px; background: url(../../assets/login_ph.png) no-repeat; content: ''; position: absolute; left: 10px; top: 9px;
					}
				}
				.reg_ipt {
					&:after {
						width: 16px; height: 21px; background: url(../../assets/login_reg.png) no-repeat; content: ''; position: absolute; left: 10px; top: 9px;
					}
				}
				
				.reg_box {
					.get_button {
						position: absolute; right: 1px; top: 1px; border: none;
						&:hover { background: none;}
					}
				}
				.submit_btn {
					margin-top: 90px; margin-bottom: 0;
					.el-button {
						width: 100%; border: none; background: #0a7bf6; border-radius: 20px; font-size: 14px; color:#fff;
					}
				}
				.hint_txt {
					 font-size: 12px; color:#333; line-height: 1; text-align: center; margin-top: 16px;
				}
			}
		}
	}
</style>
